import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { format } from "date-fns";
import { ApiErrorsDto, PortalErrorsDto } from "../../../types/ErrorLog";
import { GLOBALSETTINGS } from "../../../data/constants";
import { LoggerType } from "../../../data/Enums";
import "./ErrorLog.scss";

interface ErrorLogDetailsProps {
  open: boolean;
  handleClose: () => void;
  selectedRow: PortalErrorsDto | ApiErrorsDto | null;
  loggerType: LoggerType;
}

const ErrorLogDetails: React.FC<ErrorLogDetailsProps> = ({
  open,
  handleClose,
  selectedRow,
  loggerType,
}) => {
  const getLabelForKey = (key: string) => {
    const labels =
      loggerType === LoggerType.FrontEnd
        ? {
            errorLogId: "Id",
            userId: "User Id",
            userName: "User Name",
            errorDate: "Date Time",
            moduleId: "Module Id",
            moduleName: "Module",
            summary: "Summary",
            secondaryRecordId: "Secondary Record Id",
            details: "Details",
            dataObjectJson: "Data Object Json",
            ipAddress: "IP Address",
            userAgent: "User Agent",
            deviceSize: "Device Size",
            sessionId: "Session Id",
          }
        : {
            id: "Id",
            message: "Message",
            messageTemplate: "Message Template",
            level: "Level",
            timeStamp: "Time Stamp",
            exception: "Exception",
            properties: "Properties",
            environmentName: "Environment Name",
          };

    return labels[key] || key;
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEnforceFocus
      aria-labelledby="customized-dialog-title"
    >
      <DialogTitle id="customized-dialog-title">Error Log Details</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={() => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: "#fff",
        })}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent dividers>
        {selectedRow && (
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {Object.entries(selectedRow)
                  .filter(([key]) => key !== "totalRecords")
                  .map(([key, value]) => (
                    <TableRow key={key}>
                      <TableCell style={{ width: "200px" }}>
                        <strong>{getLabelForKey(key)}</strong>
                      </TableCell>
                      <TableCell className="table-cell">
                        {(key.includes("Date") || key.includes("timeStamp")) && value
                          ? format(value, GLOBALSETTINGS.DATE_FORMAT_TIME)
                          : String(value ?? "")}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
        <Button onClick={handleClose} autoFocus variant="contained" color="light">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorLogDetails;
